/// <reference path="skyward.ui.window.ts" />
/// <reference path="skyward.ui.modallayer.js" />
/// <reference path="skyward.ui.svg.ts" />
(
function (skyward, $, undefined)
{
    "use strict";
    skyward.fieldsearch = skyward.fieldsearch || {};
    skyward.fieldsearch.getpopup = function (callback)
    {
        var popup;
        var searchResults = { root: $("<ul/>") };
        var closedFolderSvg = skyward.svg.getSvg("ClosedFolderAlt", "TreeBrowse");
        var openFolderSvg = skyward.svg.getSvg("OpenFolderAlt", "TreeBrowse");

        var searchButton = $(this);
        var searchButtonData = searchButton.data();
        var initialInput = searchButton.closest(".js-treebrowse__fieldSearch")
                .find(".js-treebrowse__fieldSearchInput")
                .val();

        var elementData = new WeakMap();

        $.ajax(skyward.global.virtualDir + "Common/FieldSearcher/GetPopup",
        {
            type: "POST",
            dataType: "viewparthtml",
            data: searchButtonData,
            success: function(data)
            {
                var options = { width: "430px", closeOnClick: false };
                var popupButtons =
                [
                    { text: searchButtonData.saveText, "icon": "Select", additionalClasses: "selectField hidden", "click": selectField },
                    { text: "Close", "click": "close", "icon": "Close" }
                ];
                var selectedField = $();
                popup = skyward.modalLayer.showDialog(searchButtonData.dialogTitle, data, popupButtons, options);

                $.when(popup.bodyPromise).then(function ()
                {
                    var searchText = popup.content.find(".searchText");
                    searchText.focus();
                    searchText.val(initialInput);
                    searchText.on("keypress", function (event)
                    {
                        // enter key
                        if (event.which === 13)
                        {
                            performSearch();
                        }
                    });
                    popup.content.on("click", ".searchButton", null, function () { performSearch(); });
                    popup.content.on("dblclick", ".fieldSearchField", null, function ()
                    {
                        selectField();
                        return false;
                    });

                    var selectFieldButton = popup.container.find(".selectField");

                    var highlightField = function (field)
                    {
                        selectedField.children(".selectionLabel").removeClass("selected");
                        field.children(".selectionLabel").addClass("selected");
                        selectedField = field;
                        selectFieldButton.removeClass("hidden");
                    };

                    var expandCollapseFolder = function ()
                    {
                        var folder = $(this);
                        var svg = folder.children(".selectionLabel").find("svg.svgTreeBrowse");
                        if (folder.hasClass("fieldSearch-collapsed"))
                        {
                            folder.removeClass("fieldSearch-collapsed");
                            svg.replaceWith(openFolderSvg.clone());
                            var data = elementData.get(folder[0]);
                            if (!data.expanded)
                            {
                                searchResults.appendFolderChildren(data, folder[0].querySelector("ul"));
                            }
                        }
                        else
                        {
                            folder.addClass("fieldSearch-collapsed");
                            svg.replaceWith(closedFolderSvg.clone());
                        }

                        return false;
                    };

                    popup.content.on("click", ".fieldSearchField, .fieldSearchOneToMany:not(.noSelect)", null, function ()
                    {
                        highlightField($(this));
                        return false;
                    });

                    popup.content.on("dblclick", ".fieldSearchFolder, .fieldSearchOneToMany", null, expandCollapseFolder);

                    if (typeof initialInput === "string" && initialInput.length > 0)
                    {
                        performSearch();
                    }
                });

                function selectField()
                {
                    const data = $.extend(
                    {
                        moduleName: searchButtonData.startModule,
                        objectName: searchButtonData.startObject
                    },
                    elementData.get(selectedField[0]));

                    // Extract data for breadcrumbs back up to root object.
                    const foldersLeadingUpToRoot = selectedField.parentsUntil(".root").filter("li");
                    const foldersLeadingOutOfRoot = foldersLeadingUpToRoot.get().reverse();
                    const rootData = elementData.get(selectedField.closest(".root")[0]);
                    let positionObjectPath = rootData.fieldPath;
                    let displayPathText = rootData.displayName;

                    const breadcrumbData = [{
                        moduleName: rootData.moduleName,
                        objectName: rootData.objectName,
                        displayName: rootData.displayName,
                        positionObjectPath: rootData.fieldPath,
                        isOneToMany: (rootData.fieldType === "ManyToOne" ? false : true)
                    }];

                    foldersLeadingOutOfRoot.forEach(function (e)
                    {
                        const folderData = elementData.get(e);
                        positionObjectPath = positionObjectPath + "." + folderData.fieldPath;
                        displayPathText = displayPathText + " > " + folderData.displayName;
                        breadcrumbData.push(
                        {
                            moduleName: folderData.moduleName,
                            objectName: folderData.objectName,
                            fieldName: folderData.fieldPath,
                            displayName: folderData.displayName,
                            positionObjectPath: positionObjectPath,
                            isOneToMany: folderData.fieldType === "OneToMany"
                        });
                    });
                    data.breadcrumbData = breadcrumbData;
                    positionObjectPath = positionObjectPath + "." + data.fieldPath;
                    data.fieldPath = positionObjectPath;
                    data.fieldPathToParent = data.fieldPath.substring(0, data.fieldPath.lastIndexOf('.'));
                    data.positionObjectPath = positionObjectPath;
                    // This should be generating the same thing that FieldPresentationData.GetDisplayPathFromRelationshipPath() does
                    data.displayPathText = displayPathText + " > " + data.displayName;

                    popup.close();
                    if (typeof (callback) === "function")
                    {
                        callback(searchButtonData.controlToUpdate, data);
                    }
                }
            }
        });

        var performSearch = function ()
        {
            popup.container.find(".selectField").addClass("hidden");
            const textBox = popup.content.find(".searchText");
            const searchText = textBox.val();

            $.ajax(skyward.global.virtualDir + "Common/FieldSearcher/FindFields",
            {
                type: "POST",
                dataType: "JSON",
                data: $.extend({searchText:searchText}, searchButton.data()),
                success: function (fieldSearchResults)
                {
                    searchResults.root.remove();
                    if (fieldSearchResults === null)
                    {
                        textBox.attr('placeholder', 'No results found').val('');
                    }
                    else
                    {
                        searchResults = buildFieldList(fieldSearchResults);
                        searchResults.root.appendTo(popup.content);
                    }
                    popup.content.css("height", "auto");
                    popup.animateModalContents();
                }
            });
        };

        function buildFieldList(rootFolderData)
        {
            var totalRows = 0;

            // Arbitrary limit: having too many rows visible causes severe rendering delays in the browser
            var closedFolderRowThreshold = 1000;

            var rootFolder = $(buildFolder(rootFolderData));
            rootFolder.addClass("root");
            var root = $("<ul/>").append(rootFolder);

            var result =
            {
                root: root,
                appendFolderChildren: appendFolderChildren
            };
            return result;

            function appendFolderChildren(data, folderContents)
            {
                $.each(data.fields, function (i, fieldData)
                {
                    folderContents.appendChild(buildFieldListItem(fieldData, fieldTemplates));
                });
                totalRows += data.fields.length;
                data.fields = undefined;

                $.each(data.folders, function (i, folderData)
                {
                    var oneToManyListItem = buildFolder(folderData);
                    folderContents.appendChild(oneToManyListItem);
                });
                totalRows += data.folders.length;
                data.folders = undefined;

                $.each(data.oneToManyRelationships, function (i, oneToManyData)
                {
                    var oneToManyListItem = buildOneToMany(oneToManyData);
                    folderContents.appendChild(oneToManyListItem);
                });
                totalRows += data.oneToManyRelationships.length;
                data.oneToManyRelationships = undefined;

                data.expanded = true;
            }

            function buildOneToMany(oneToManyData)
            {
                var template = totalRows < closedFolderRowThreshold ? oneToManyTemplate : closedOneToManyTemplate;
                var oneToManyListItem = buildFolderListItem(oneToManyData, template);
                if (totalRows < closedFolderRowThreshold)
                {
                    appendFolderChildren(oneToManyData, oneToManyListItem.querySelector("ul"));
                }
                return oneToManyListItem;
            }

            function buildFolder(folderData)
            {
                var template = totalRows < closedFolderRowThreshold ? openFolderTemplate : closedFolderTemplate;
                var folderListItem = buildFolderListItem(folderData, template);
                if (totalRows < closedFolderRowThreshold)
                {
                    appendFolderChildren(folderData, folderListItem.querySelector("ul"));
                }
                return folderListItem;
            }

            function buildFolderListItem(folderData, folderTemplate)
            {
                var folderListItem = folderTemplate.cloneNode(true);

                folderListItem.querySelector(".fieldSearchLabel").textContent = folderData.displayName;
                elementData.set(folderListItem, folderData);
                return folderListItem;
            }

            function buildFieldListItem(fieldData, fieldTemplateCache)
            {
                var fieldListItem = fieldTemplateCache(fieldData.svgClass).cloneNode(true);
                var labelText = fieldData.displayName;
                if (fieldData.isCalculated || fieldData.isOperation)
                {
                    labelText += "*";
                }
                fieldListItem.querySelector(".fieldSearchLabel").textContent = labelText;

                elementData.set(fieldListItem, fieldData);
                return fieldListItem;
            }
        }

        var baseFolderTemplate = $(
            "<li class='fieldSearchFolder noSelect' >" +
                "<span class='selectionLabel'>" + 
                    "<span class='fieldSearchLabel noSelect'></span>" +
                "</span>" +
                "<ul />" +
            "</li>");
        var closedFolderTemplate = baseFolderTemplate.clone().addClass("fieldSearch-collapsed");
        closedFolderTemplate.find(".selectionLabel").prepend(closedFolderSvg.clone());
        closedFolderTemplate = closedFolderTemplate[0];
        var openFolderTemplate = baseFolderTemplate;
        openFolderTemplate.find(".selectionLabel").prepend(openFolderSvg.clone());
        openFolderTemplate = openFolderTemplate[0];

        var oneToManyTemplate = $(
            "<li class='fieldSearchOneToMany'>" +
                "<span class='selectionLabel'>" +
                    "<svg />" +
                    "<span class='fieldSearchLabel'></span>" +
                "</span>" +
                "<ul />" +
            "</li>");
        oneToManyTemplate.toggleClass("noSelect", !searchButtonData.allowSelectingOneToMany);
        oneToManyTemplate.find("svg").replaceWith(skyward.svg.getSvg("OneToMany", "TreeBrowse"));
        var closedOneToManyTemplate = oneToManyTemplate.clone().addClass("fieldSearch-collapsed")[0];
        oneToManyTemplate = oneToManyTemplate[0];

        var fieldListItemTemplate = $(
            "<li class='fieldSearchField'>" +
                "<span class='selectionLabel'>" +
                    "<svg />" +
                    "<span class='fieldSearchLabel'></span>" +
                "</span>" +
            "</li>");
        var fieldTemplates = skyward.extensions.createCache(function (svgClass)
        {
            var template = fieldListItemTemplate.clone();
            template.find("svg").replaceWith(skyward.svg.getSvg(svgClass, "TreeBrowse"));
            return template[0];
        });
    };
}(window.skyward = window.skyward || {}, window.jQuery)
);
